


















































/* Created- 22 - Mar - 2019 */
import { Component, Vue, Prop, Inject, Watch } from "vue-property-decorator";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaList2Line from "@/Ui-Components/Common/List/ParticaList2LineV3.vue";
import { ContentStreamSubscriberDTO, ContentStreamSubscriberDTOStatus } from "../../Generated/ParticaAPI";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig } from "../../Models/Buttons";
import { IContentStreamService } from "../../BusinessServices/contentstream";
import { ParticaListContent, ParticaListLineContent } from "../../Models/ParticaListModel";
import ParticaBaseView from "../Base/ParticaBaseView.vue";
import { BreadcrumbItem } from "../../Models/Breadcrumb";

@Component(
	{
		name: "ContentStreamSubs",
		components: {
			ParticaCard,
			ParticaView,
			ParticaList2Line,
			ParticaColumnContainer
		}
	})
export default class ContentStreamSubs extends ParticaBaseView {
	@Prop() private id: number;
	private contentStreamService: IContentStreamService;
	private listdata: ParticaListContent = new ParticaListContent();
	private showInactive: boolean = false;
	private showActive: boolean = true;

	private buttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.CONTENT_STREAM_REQUEST_CANCEL_SUBSCRIPTION, label: "Cancel Subscription" } as ButtonConfig,
	];

	private async reload() {
		await this.init();
	}

	private async eventHandler(data: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (data.action) {
				case eParticaAction.NONE: {
					this.dialog.show = false;
					break;
				}
				case eParticaAction.CONTENT_STREAM_CANCEL_SUBSCRIPTION: {
					const subscriber = data.item as ContentStreamSubscriberDTO;
					this.trackEvent("CONTENT_STREAM_CANCEL_SUBSCRIPTION", subscriber);
					await this.contentStreamService.CancelSubscription(subscriber.contentStreamSubscriptionId as number);
					this.dialog.show = false;
					await this.init();
					break;
				}
				case eParticaAction.CONTENT_STREAM_REQUEST_CANCEL_SUBSCRIPTION: {
					const subscriber = data.item.item as ContentStreamSubscriberDTO;
					this.dialog.title = `Confirm cancelling the subscription for '${subscriber.subscriber}'`;
					this.dialog.message2 = "Any articles awaiting tailoring will be removed.";
					if (subscriber.cbStatus !== undefined) {
						switch (subscriber.status) {
							case ContentStreamSubscriberDTOStatus.Active: { // partica good
								switch (subscriber.cbStatus.ok as boolean) { // cb good
									case true: {
										// cancel both
										this.dialog.message = `This will cancel the Partica and Chargebee subscriptions`;
										this.dialog.item = subscriber;
										this.dialog.action = eParticaAction.CONTENT_STREAM_CANCEL_SUBSCRIPTION;
										break;
									}
									case false: { // cb bad
										// cancel partica
										this.dialog.message = `This will cancel the Partica subscription`;
										this.dialog.item = subscriber;
										this.dialog.action = eParticaAction.CONTENT_STREAM_CANCEL_SUBSCRIPTION;
										break;
									}
								}
								break;
							}
							default: { // partica bad
								switch (subscriber.cbStatus.ok as boolean) {
									case true: {  // cb good
										// cancel cb
										this.dialog.message = `This will cancel the Chargebee subscription`;
										this.dialog.item = subscriber;
										this.dialog.action = eParticaAction.CONTENT_STREAM_CANCEL_SUBSCRIPTION;
										break;
									}
									case false: { // cb bad
										// already both cancelled.
										this.dialog.title = `The subscriptions are already cancelled.`;
										this.dialog.message = "This will do nothing.";
										this.dialog.item = subscriber;
										this.dialog.action = eParticaAction.NONE;
										break;
									}
								}
								break;
							}
						}
					}
					this.dialog.show = true;
					break;
				}

				default: {
					this.baseEventHandler(data);
				}
			}
		} catch (e) {
			this.ShowErrorDialog(e, `Error occured processing event. ${getActionName(data.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.breadcrumbs.push({ text: "Subscribers" } as BreadcrumbItem);
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.contentStreamService = this.particaServices.getContentStreamService();
			const subscribers: ContentStreamSubscriberDTO[] = await this.contentStreamService.getContentStreamSubscriptions(this.id);
			this.listdata.lines = [];
			subscribers.forEach(subscriber => {
				const line: ParticaListLineContent = new ParticaListLineContent();
				line.item = subscriber;
				line.id = (subscriber.contentStreamSubscriptionId as number).toString();
				line.title = subscriber.subscriber as string;
				line.subtitle = `${subscriber.level} : ${subscriber.requiresCuration}<br>`;
				if (subscriber.cbStatus !== undefined) {
					const color: string = "black";
					switch (subscriber.status) {
						case ContentStreamSubscriberDTOStatus.Active: { // partica good
							switch (subscriber.cbStatus.ok) {
								case true: { // cb good
									// color = "green";
									break;
								}
								case false: { // cb bad
									// color = "red";
									break;
								}
							}
							break;
						}
						default: { // partica bad
							switch (subscriber.cbStatus.ok) {
								case true: { // cb good
									// color = "red";
									break;
								}
								case false: { // cb bad
									// color = "green";
									break;
								}
							}
							break;
						}
					}
					line.subtitle += `<span style="color:${color}">Partica : ${subscriber.status}<br>`;
					if (subscriber.cbStatus.ok) {
						line.subtitle += `Chargebee : ${subscriber.cbStatus.status}`;
					} else {
						line.subtitle += `Chargebee : ${subscriber.cbStatus.status}`;
					}
					line.subtitle += `<br>Subscription Id : ${subscriber.cbStatus.id}</span>`;
				}
				if (this.showInactive === true && subscriber.status === ContentStreamSubscriberDTOStatus.Inactive ||
					this.showActive === true && subscriber.status === ContentStreamSubscriberDTOStatus.Active) {
					this.listdata.lines.push(line);
				}
			});
		} catch (e) {
			this.ShowErrorDialog(e, "Error occured loading Content Stream Subscriptions.");
		} finally {
			this.LoadingEnd();
		}
	}
}
